import React from 'react';

const ViewContext = React.createContext({
  side: null,
});

export default ViewContext;
